import { m } from 'framer-motion';
import { IconSun, IconMoon } from '@tabler/icons-react';

export function ThemeToggle({ isDark, onToggle }) {
  return (
    <m.button
      onClick={onToggle}
      className={`relative flex h-9 w-9 items-center justify-center rounded-full transition-colors duration-300 ${
        isDark
          ? 'bg-white/[0.04] text-neutral-500 hover:bg-white/[0.08] hover:text-neutral-200'
          : 'bg-black/[0.04] text-neutral-500 hover:bg-black/[0.07] hover:text-neutral-900'
      }`}
      whileTap={{ scale: 0.94 }}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      <m.div
        initial={false}
        animate={{ rotate: isDark ? 0 : 180 }}
        transition={{ duration: 0.45, ease: [0.22, 0.61, 0.36, 1] }}
        className="flex items-center justify-center"
      >
        {isDark ? (
          <IconMoon className="h-4 w-4" strokeWidth={1.5} />
        ) : (
          <IconSun className="h-4 w-4" strokeWidth={1.5} />
        )}
      </m.div>
    </m.button>
  );
}
